import { PriceStyle } from "@omni/ui/components/Price/price.style";

import { usePriceContext } from "@/components/Price/context/price.context";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    className?: string;
};

export const Main = ({ className }: Props) => {
    const { price, size } = usePriceContext();

    const [wholePrice, decimalPrice] = formatPrice(price, {
        decimal: PriceStyle.decimalFormat
    }).split(",");

    return (
        <span
            className={PriceStyle.main({
                size: size,
                className: className
            })}
        >
            <span
                className={PriceStyle.main.whole({
                    size: size
                })}
            >
                {wholePrice}
            </span>
            <span
                className={PriceStyle.main.decimal({
                    size: size
                })}
            >
                {decimalPrice}
            </span>
        </span>
    );
};
